import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Button, FormFeedback } from 'reactstrap';
import { Link, useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash, FaLock } from 'react-icons/fa';
import { useDataContext } from '../Context/dataContext';
import remesalogo from '../Assets/Images/remesalogo.png';
import loginImage from '../Assets/Images/loginn.jpg';

function RecoverUpdate() {
  const history = useHistory();
  const { url } = useDataContext();
  const { id, email } = useParams();

  const [userEmail, setUserEmail] = useState({});
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [touchedPassword, setTouchedPassword] = useState(false);
  const [touchedConfirm, setTouchedConfirm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);



  const fetchUser = useCallback(async () => {
    try {
      const res = await axios.get(`${url}/Users/email/${email}`);
      setUserEmail(res.data);
    } catch (error) {
      console.error(error);
    }
  }, [email, url]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (updateSuccess) return; // Evita múltiples envíos
  
    setIsSubmitting(true);
    try {
      await axios.put(`${url}/Users/PasswordRecovery/${id}`, {
        use_password: password.toLowerCase(),
      });
      toast.success('Contraseña actualizada correctamente');
      setUpdateSuccess(true);
      setTimeout(() => history.push('/Login'), 3000);
    } catch (error) {
      const msg =
        error.response?.data?.data?.message || 
        error.message ||
        'Error al actualizar la contraseña';
      toast.error(msg);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  
  const isPasswordValid = password.length >= 8;
  const isMatching = password === confirmPassword;
  const isDataValid =
    email === userEmail.use_email && parseInt(id) === userEmail.use_id;

  return (
    <div className="recover-page">
      <div className="recover-container">
        <div className="recover-image">
          <img src={loginImage} alt="Recuperación" />
        </div>

        <div className="recover-form-wrapper">
          <Link to="/">
            <img src={remesalogo} alt="Logo" className="recover-logo" />
          </Link>

          <form className="recover-form" onSubmit={handleSubmit}>
            <label>
              <FaLock className="icon" />
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Nueva contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => setTouchedPassword(true)}
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </label>
            {touchedPassword && !isPasswordValid && (
              <FormFeedback className="d-block">
                Mínimo 8 caracteres
              </FormFeedback>
            )}

            <label>
              <FaLock className="icon" />
              <input
                type="password"
                placeholder="Confirmar contraseña"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onBlur={() => setTouchedConfirm(true)}
                required
              />
            </label>
            {touchedConfirm && !isMatching && (
              <FormFeedback className="d-block">
                Las contraseñas no coinciden
              </FormFeedback>
            )}

            {!isDataValid && (
              <FormFeedback className="d-block mt-2">
                El enlace no es válido o ha expirado
              </FormFeedback>
            )}

{!updateSuccess && (
  <Button
    type="submit"
    className="recover-button"
    color="primary"
    disabled={!isPasswordValid || !isMatching || !isDataValid || isSubmitting}
  >
    {isSubmitting ? (
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      />
    ) : null}
    {isSubmitting ? 'Procesando...' : 'Actualizar contraseña'}
  </Button>
)}
{updateSuccess && (
  <p className="text-success mt-3">
    Contraseña cambiada con éxito. Serás redirigido al inicio de sesión...
  </p>
)}




            <Link to="/Login" className="recover-back">
              Volver al inicio de sesión
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
}

export { RecoverUpdate };
